module.exports = __webpack_public_path__ + "img/home_funeng_bg_commodity.cca473d3.png";